import script from "./conversation-refresh-icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./conversation-refresh-icon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__